
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Admin from '../pages/admin/page';
import AICourse from '../pages/ai-course/page';
import ResearchPapers from '../pages/research-papers/page';
import PDFViewer from '../pages/pdf-viewer/page';
import Support from '../pages/support/page';
import GigaSchoolProposal from '../pages/giga-school-proposal/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/ai-course',
    element: <AICourse />,
  },
  {
    path: '/research-papers',
    element: <ResearchPapers />,
  },
  {
    path: '/pdf/:filename',
    element: <PDFViewer />,
  },
  {
    path: '/support',
    element: <Support />,
  },
  {
    path: '/giga-school-proposal',
    element: <GigaSchoolProposal />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
